import axios from 'axios'
import {
  fetchClientRdvNotifications,
  fetchPropRdvNotifications,
  fetchReminderNotifications,
  fetchSeeksMatchNotifications,
  setDefaultState,
} from '../store/actions'
import { store } from '../store'
import { hasRight } from './rightsHelper' // AJOUT DU HELPER

const API_URL = process.env.REACT_APP_BASE_URL
axios.defaults.baseURL = API_URL

// AJOUT : Générateur dynamique d'URL pour les médias (Images/Fichiers)
export const getMediaUrl = (filename) => {
  if (!filename) return '';

  // On nettoie la chaîne : on retire "medias/" ou "/medias/" s'il est déjà présent au début
  const cleanFilename = filename.replace(/^\/?medias\//, '');

  if (process.env.NODE_ENV === 'production') {
    return `/medias/${cleanFilename}`;
  }

  const baseUrl = process.env.REACT_APP_BASE_URL
    ? process.env.REACT_APP_BASE_URL.replace(/\/api\/?$/, '')
    : 'http://localhost:3300';

  return `${baseUrl}/medias/${cleanFilename}`;
};

axios.interceptors.request.use(
  async (config) => {
    if (config.headers) {
      const shouldUpdateNotifications =
        config?.params?.shouldUpdateNotifications || undefined

      if (shouldUpdateNotifications) {
        // SÉCURITÉ : On vérifie les droits depuis le store Redux avant le rafraîchissement
        const state = store.getState()
        const userObj = state.auth?.userObj

        if (hasRight(userObj, 'property_appointments', 'READ')) {
          store.dispatch(fetchPropRdvNotifications())
        }
        if (hasRight(userObj, 'client_appointments', 'READ')) {
          store.dispatch(fetchClientRdvNotifications())
        }
        if (hasRight(userObj, 'archive')) {
          store.dispatch(fetchReminderNotifications())
        }
        if (hasRight(userObj, 'matching')) {
          store.dispatch(fetchSeeksMatchNotifications())
        }
      }
    }
    return config
  },
  (error) => {
    console.log({ error })
    return Promise.reject(error)
  },
)

axios.interceptors.response.use(
  async (response) => {
    return response
  },
  (error) => {
    if (error.response && error.response.status === 403) {
      // Différencier une session expirée d'un simple refus de droits
      // L'AuthMiddleware renvoie la string "Forbidden". Le RightsMiddleware renvoie un JSON.
      if (error.response.data === 'Forbidden') {
        store?.dispatch(setDefaultState())
        //window.location.replace('/')
      }
    }
    return Promise.reject(error)
  },
)

export const setHeaders = async (accessToken, deviceKey, userId) => {
  try {
    axios.defaults.headers.common['Authorization'] = accessToken
    axios.defaults.headers.common['key'] = deviceKey
    axios.defaults.headers.common['id'] = userId
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export default axios